var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnatomicalDeadspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 272.28 388.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:none;}.cls-1{stroke:#bababa;stroke-linejoin:round;}.cls-1,.cls-3,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-linecap:round;}.cls-1,.cls-3{stroke-width:2px;}.cls-2{fill:#fcdad6;stroke:#f16673;stroke-width:3px;}.cls-2,.cls-3,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-3{stroke:#008dff;fill:url(#linear-gradient);}.cls-4{font-size:14px;font-family:OpenSans-Semibold, Open Sans;font-weight:600;}.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#505050;}.cls-6{stroke-dasharray:4.91 4.91;}.cls-7{stroke-dasharray:5.13 5.13;}.cls-8{stroke-dasharray:4.77 4.77;}.cls-9{stroke-dasharray:5.13 5.13;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 137.11,
    y1: 32.68,
    x2: 137.11,
    y2: 295.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f4fbfd",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#e5f4fa",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#daf0f8",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d4eef7",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d2edf7",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#a8cdf9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#82b0fb",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6298fc",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4a85fd",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#3878fe",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#2e70ff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a6dff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "w3JBE3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.67,314.42c-.7-6.62-4.78-12.12-6-18.72-.92-5.17-.32-10.94-3.83-15.54l11.42-47.3c-3.81,14.68-6.64,29.71-11.77,43.91-3.35,9.28-7.32,77.27-5.5,102.06.22,3,.23,6,.62,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.39,312c-1.87-10.84-1.44-21.66-1-32.63.66-18.81,5.49-36.91,7.83-55.42,2.59-20.5,12-39.81,34-45.54,3.45-.9,6.7-2.92,9.79-4.84,12.84-8,25.87-15.55,40-21.23,9-3.61,14.37-7.24,14.71-17.32,0,0-1.16-14.35-2.47-15.74a36.14,36.14,0,0,1-9.62-18.46c-.27-1.46-1.05-2.9-1.87-2.94-4.92-.21-4.67-4.3-5.12-7.18-.56-3.59-1.82-7-2.32-10.55-.53-3.78-2.19-7.4-.59-11.48,1-2.52,1.85-3.72,4.52-2.59l-.88-.88c-.8-10.41-.75-20.73,2.62-30.81C98.18,15.54,114.12,1.37,135,1c24.3-.43,42.06,17.53,46.67,40,1.66,8.06,1.32,16.11.85,24.21l-.88.88c2.67-1.13,3.54.07,4.52,2.59,1.6,4.08-.06,7.7-.59,11.48-.5,3.56-1.76,7-2.32,10.55-.45,2.88-.2,7-5.13,7.18-.81,0-1.59,1.48-1.86,2.94a36.21,36.21,0,0,1-9.62,18.46c-1.31,1.39-2,15.74-2,15.74.75,12.56,9.12,15.79,19.6,19.75s19.89,9.73,29.39,15.48c5,3,9.62,6.8,15.44,8.25,22.1,5.53,31.41,24.93,34,45.45,2.32,18.51,7.16,36.61,7.82,55.42.39,11,.82,21.79-1.05,32.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.63,387.82c.55-11.15,1-22.3,1.65-33.44,1.19-20.23,3.87-40-2.22-59.64-2-6.37-2.83-11.72-4.49-17.88-4-14.64-9.09-29-11.59-44l11.42,47.3c-3.51,4.6-2.91,10.37-3.83,15.54-1.18,6.6-5.26,12.1-6,18.72"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103,117.09c6,6,17.62,18.62,26.41,19.07,5.5.28,8.08.43,13.59.45,6.33,0,20-12.52,24-17.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.46,263.42c0,41.76,4.25,99.15,23.42,89.42,61-31,35.63-27.68,33.84-99.26-1-41.75-1.17-64-12.06-64C90.14,189.54,63.46,206.15,63.46,263.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212,265.23c0,41.76-4.26,99.15-23.42,89.42-61-31-35.64-27.68-33.85-99.26,1-41.75,1.17-64,12.07-64C185.32,191.35,212,208,212,265.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.71,78.59c0,79-2.5,143.5-7,148-4.78,4.78-16.84,14.88-27,14-14-1.22-20.59-7.83-22-5-2,4,10.5,4.5,16,10,1.52,1.52-22.61,6.78-20,12,2,4,17-7,20-4,2.37,2.37-15,18-9,20s10-19,15-19c1.51,0,1,17,5,17s-1-16.74,0-20c1.17-3.77,6-4.36,15-8a112.9,112.9,0,0,0,13.16-6.35,12.68,12.68,0,0,1,6.21-1.65h2a12.62,12.62,0,0,1,6.21,1.65,113.71,113.71,0,0,0,13.17,6.35c9,3.64,13.83,4.23,15,8,1,3.26-4,20,0,20s3.49-17,5-17c5,0,9,21,15,19s-11.37-17.63-9-20c3-3,18,8,20,4,2.61-5.22-21.52-10.48-20-12,5.5-5.5,18-6,16-10-1.41-2.83-8,3.78-22,5-10.17.88-22.22-9.22-27-14-4.5-4.5-7-69-7-148"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(207.77 68.52)"
  }, "Nose"), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(207.77 92.52)"
  }, "Pharynx"), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(207.77 117.52)"
  }, "Trachea"), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(207.77 140.52)"
  }, "Bronchi"), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 137.01,
    y1: 78.59,
    x2: 139.45,
    y2: 78.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 144.22,
    y1: 76.92,
    x2: 199.18,
    y2: 64.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 201.57,
    y1: 63.65,
    x2: 204.01,
    y2: 63.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 136.51,
    y1: 111.59,
    x2: 138.87,
    y2: 110.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 143.7,
    y1: 109.03,
    x2: 199.24,
    y2: 89.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 201.65,
    y1: 88.43,
    x2: 204.01,
    y2: 87.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 204.51,
    y1: 115.59,
    x2: 202.32,
    y2: 116.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 198.15,
    y1: 119.1,
    x2: 141.79,
    y2: 150.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 139.7,
    y1: 151.38,
    x2: 137.51,
    y2: 152.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 204.51,
    y1: 136.59,
    x2: 203.8,
    y2: 138.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 202.34,
    y1: 143.9,
    x2: 173.95,
    y2: 239.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 173.22,
    y1: 242.19,
    x2: 172.51,
    y2: 244.59
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnatomicalDeadspace);
export default __webpack_public_path__ + "static/media/AnatomicalDeadspace.4a935ad8.svg";
export { ForwardRef as ReactComponent };